/**
 * Reveal on scroll.
 *
 * Flags [data-scroll] elements with data-scroll="in" once they enter the
 * viewport, driving the theme's .fade-in / .ease-* appearance transitions.
 */
const revealElement = (element) => {
  element.setAttribute('data-scroll', 'in');
};

let sharedObserver = null;

const observeElements = () => {
  const elements = document.querySelectorAll(
    '[data-scroll]:not([data-scroll="in"])'
  );

  if (!elements.length) {
    return;
  }

  if (
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    elements.forEach(revealElement);
    return;
  }

  if (!sharedObserver) {
    sharedObserver = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            revealElement(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );
  }

  elements.forEach((element) => sharedObserver.observe(element));
};

const initReveal = () => {
  observeElements();

  // Let async-rendered content (e.g. AJAX "load more" cards) opt into the
  // same reveal pass by dispatching `reveal:scan` after it lands in the DOM.
  document.addEventListener('reveal:scan', observeElements);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReveal);
} else {
  initReveal();
}
